"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _filterAdvancedBloom = require("@pixi/filter-advanced-bloom");
var _filterShockwave = require("@pixi/filter-shockwave");
var _filterZoomBlur = require("@pixi/filter-zoom-blur");
var _pixi = require("pixi.js");
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FilterManager = exports["default"] = /*#__PURE__*/function () {
  //https://pixijs.io/pixi-filters/tools/demo/
  //https://pixijs.io/pixi-filters/docs/
  function FilterManager(container, starWarp) {
    _classCallCheck(this, FilterManager);
    //Manages the filters, including the blur on the outside, as well as the bulging in the middle
    _defineProperty(this, "starContainer", void 0);
    _defineProperty(this, "shockwaveFilter", void 0);
    _defineProperty(this, "bulgeShock", void 0);
    _defineProperty(this, "cornerBlur", void 0);
    _defineProperty(this, "blurStrengthWarp", void 0);
    _defineProperty(this, "blurStrengthIdle", void 0);
    _defineProperty(this, "advanceBloom", void 0);
    _defineProperty(this, "shockSin", void 0);
    _defineProperty(this, "bulgeMin", void 0);
    _defineProperty(this, "bulgeMax", void 0);
    _defineProperty(this, "iOS", void 0);
    _defineProperty(this, "point", void 0);
    this.starContainer = starWarp;
    this.shockwaveFilter = new _filterShockwave.ShockwaveFilter();
    this.shockwaveFilter.time = 3;
    this.bulgeShock = new _filterShockwave.ShockwaveFilter();
    this.bulgeShock.time = 3;
    this.cornerBlur = new _filterZoomBlur.ZoomBlurFilter();
    this.blurStrengthWarp = 0.5;
    this.blurStrengthIdle = 0.1;
    this.cornerBlur.center = [window.innerWidth / 2, window.innerHeight / 2];
    this.cornerBlur.innerRadius = window.innerWidth * 0.5;
    this.cornerBlur.radius = window.innerWidth;
    this.cornerBlur.strength = this.blurStrengthWarp;
    var options = {
      threshold: 0,
      bloomScale: 2,
      brightness: 2,
      blur: 1,
      quality: 5
    };
    this.advanceBloom = new _filterAdvancedBloom.AdvancedBloomFilter(options);
    this.starContainer.filterArea = new _pixi.Rectangle(0, 0, 1000000, 1000000);
    this.shockSin = 0;
    this.bulgeMin = 0.3;
    this.bulgeMax = 0.5;

    // very basic safari detection
    this.iOS = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
  return _createClass(FilterManager, [{
    key: "update",
    value: function update(delay) {
      this.advanceBloom.bloomScale -= 2 * 1 / 60;
      this.advanceBloom.bloomScale = Math.max(this.advanceBloom.bloomScale, -1);
      this.shockSin += 0.02;
      this.bulgeShock.time = (Math.sin(this.shockSin) * this.bulgeMax + this.bulgeMax) * this.bulgeMin;
    }
  }, {
    key: "pulse",
    value: function pulse() {
      this.shockwaveFilter.time = 0;
      _gsap["default"].to(this.shockwaveFilter, {
        duration: 1,
        time: 3
      });
      this.advanceBloom.bloomScale = 2;
      if (this.iOS) {
        this.starContainer.filters = [this.shockwaveFilter
        // this.advanceBloom, Ruins performance for safari both does!
        // this.bulgeShock, Ruins performance for safari
        ];
      } else {
        this.starContainer.filters = [this.shockwaveFilter, this.advanceBloom, this.bulgeShock];
      }
    }
  }, {
    key: "setBlurEffect",
    value: function setBlurEffect(idle) {
      if (idle) {
        this.cornerBlur.strength = this.blurStrengthIdle;
      } else {
        this.cornerBlur.strength = this.blurStrengthWarp;
      }
    }
  }, {
    key: "removeEffects",
    value: function removeEffects(target) {
      target.filters = [];
    }
  }, {
    key: "resize",
    value: function resize(height, width, offset, ringScale) {
      this.point = new _pixi.Point(width / 2, height / 2 - offset);
      this.cornerBlur.center = [width / 2, height / 2 - offset];
      this.shockwaveFilter.center = this.point;
      this.bulgeShock.center = this.point;
      if (ringScale) {
        this.bulgeMax = ringScale * 0.5;
        this.bulgeMin = ringScale * 0.3;
      }
    }
  }, {
    key: "lerp",
    value: function lerp(v0, v1, t) {
      return v0 * (1 - t) + v1 * t;
    }
  }]);
}();
//# sourceMappingURL=FilterManager.js.map